import { render, staticRenderFns } from "./qimensubmit.vue?vue&type=template&id=16460036&scoped=true"
import script from "./qimensubmit.vue?vue&type=script&lang=js"
export * from "./qimensubmit.vue?vue&type=script&lang=js"
import style0 from "./qimensubmit.vue?vue&type=style&index=0&id=16460036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16460036",
  null
  
)

export default component.exports